var React = require('react');

function IconEmailInline (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M16.5,0C7.387,0,0,7.387,0,16.5C0,25.613,7.387,33,16.5,33C25.613,33,33,25.613,33,16.5C33,7.387,25.613,0,16.5,0z\r\n\t\t M25.5,22.125c0,0.621-0.504,1.125-1.125,1.125H16.5H8.625c-0.621,0-1.125-0.504-1.125-1.125v-9.408l8.375,5.601\r\n\t\tc0.378,0.253,0.873,0.253,1.25,0l8.375-5.601V22.125z M17.125,15.351c-0.378,0.253-0.872,0.253-1.25,0L7.5,9.75h18L17.125,15.351z"})));
}

IconEmailInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"33px","height":"33px","viewBox":"0 0 33 33","enableBackground":"new 0 0 33 33","xmlSpace":"preserve"};

module.exports = IconEmailInline;

IconEmailInline.default = IconEmailInline;
